import { CheckboxCheckedSvg, CheckboxIndeterminateSvg, CheckboxUncheckedSvg } from "@/components/Icon/Icon";
import { alpha, Checkbox, CheckboxProps, Icon, styled } from "@mui/material";

const OutlinedChecked = (props: CheckboxProps) => {
  return (
    <Checkbox
      disableRipple
      checkedIcon={
        <Icon
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            transform: "scale(0.9)"
          }}
        >
          <CheckboxCheckedSvg />
        </Icon>
      }
      icon={
        <Icon
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            transform: "scale(0.9)"
          }}
        >
          <CheckboxUncheckedSvg />
        </Icon>
      }
      indeterminateIcon={
        <Icon
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            transform: "scale(0.9)"
          }}
        >
          <CheckboxIndeterminateSvg />
        </Icon>
      }
      {...props}
    />
  );
};

const StyledCheckbox = styled(OutlinedChecked)(({ theme }) => ({
  "&": {
    stroke: theme.palette.text.primary
  },
  "&:hover svg": {
    fill: alpha("#000000", 0.08)
  },
  "&:active svg": {
    fill: alpha("#000000", 0.1)
  },
  "&.MuiCheckbox-indeterminate > span svg": {
    stroke: theme.palette.text.primary
  },
  "&.Mui-disabled > *": {
    stroke: `${theme.palette.text.secondary} !important`,
    fill: "none"
  },
  "&.Mui-disabled > span svg": {
    stroke: `${theme.palette.text.secondary} !important`,
    fill: "none"
  }
}));
export { StyledCheckbox as Checkbox };
